// import * as XLSX from 'xlsx';
// import { fetchObjectives } from './objectivesManager.util';
// import { fetchIssueRegister } from './fetchIssueRegister.util';
// import { fetchLegalObligations } from './legalObligationsManager.util';
// import { getInterestedParties } from './getInterestedParties.util';
// import { fetchScopeData } from './scopeManager.util';
// import { fetchRoles } from './rolesManager.util';
// import { fetchISMSRoles } from './ismsRolesManager.util';
// import { nameFromUID } from './nameFromUID.util';


// export class TableExporter {
//     private tables: Map<string, HTMLTableElement>;

//     constructor() {
//         this.tables = new Map();
//     }

//     /**
//      * Add a table to be exported
//      * @param sheetName The name for this table's sheet
//      * @param table The HTML table element
//      */
//     public addTable(sheetName: string, table: HTMLTableElement): void {
//         this.tables.set(sheetName, table);
//     }

//     /**
//      * Convert HTML table to worksheet data
//      */
//     private async getTableData(componentName: string): Promise<{ headers: string[], rows: Promise<any[][]>, error?: string }> {
//         try {
//             // Map component names to their data fetching functions
//             const dataFetchers: { [key: string]: () => Promise<any[]> } = {
//                 'objectivesTable': async () => await fetchObjectives(),
//                 'issueRegisterTable': async () => await fetchIssueRegister(window.companyID),
//                 // 'communicationTable': () => fetchCommunications(),
//                 'legalObligationsTable': async () => await fetchLegalObligations(),
//                 'interestedPartiesTable': async () => {
//                     const result = await getInterestedParties(window.companyID, { useSnapshot: false });
//                     if (typeof result === 'function') {
//                         return []; // Return empty array if we got an unsubscribe function
//                     }
//                     return Object.values(result || {}); // Convert object to array
//                 },
//                 'scopeTable': async () => await fetchScopeData(),
//                 'ismsRolesTable': async () => await fetchISMSRoles(),
//                 'committeeRolesTable': async () => await fetchRoles(true)
//             };

//             const headerMappings: { [key: string]: string[] } = {
//                 'objectivesTable': ['ID', 'Objective', 'Target Date'],
//                 'issueRegisterTable': ['Type', 'Name', 'Description'],
//                 // 'communicationTable': ['What', 'When', 'Who', 'How'],
//                 'legalObligationsTable': ['Requirement', 'Owner', 'Update Method'],
//                 'interestedPartiesTable': ['Party', 'Party Requirement', 'Outcome on Management System', 'Frameworks'],
//                 'scopeTable': ['Scope Area', 'Description'],
//                 'ismsRolesTable': ['Role Name', 'Description'],
//                 'committeeRolesTable': ['Name', 'Team', 'ISMS Role', 'ISMS Committee Role']
//             };

//             const fetcher = dataFetchers[componentName];
//             if (!fetcher) {
//                 return {
//                     headers: [],
//                     rows: [],
//                     error: `No data fetcher found for component: ${componentName}`
//                 };
//             }

//             console.log(`Fetching data for ${componentName}...`);

//             const data = await fetcher();
//             console.log(`Fetched data for ${componentName}...`, data);
//             if (!data || !Array.isArray(data)) {
//                 return {
//                     headers: [],
//                     rows: [],
//                     error: `Invalid data returned for component: ${componentName}`
//                 };
//             }

//             const headers = headerMappings[componentName];
//             if (!headers) {
//                 return {
//                     headers: [],
//                     rows: [],
//                     error: `No header mapping found for component: ${componentName}`
//                 };
//             }

//             const rows = await this.formatDataToRows(data, componentName);
//             return { headers, rows };
//         } catch (error) {
//             console.error(`Error fetching data for ${componentName}:`, error);
//             return {
//                 headers: [],
//                 rows: [],
//                 error: `Failed to fetch data: ${error.message || 'Unknown error'}`
//             };
//         }
//     }

//     private static camelCaseToSpaces(str: string): string {
//         let spaced = str.replace(/([a-z])([A-Z])/g, '$1 $2');

//         spaced = spaced.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');

//         const capitalized = spaced.replace(/\b\w/g, char => char.toUpperCase());

//         return capitalized;
//     }

//     private async formatDataToRows(data: any[], componentName: string): Promise<any[][]> {
//         // Map component names to their row formatting functions
//         const formatters: { [key: string]: (item: any) => Promise<any[]> } = {
//             'objectivesTable': async (item) => [item.id, item.objectiveText, item.objectiveTargetDate],
//             'issueRegisterTable': async (item) => [item.type, item.name, item.description],
//             // 'communicationTable': async (item) => [item.what, item.when, item.who, item.how],
//             'legalObligationsTable': async (item) => [item.requirement, await nameFromUID(item.owner), item.updateMethod],
//             'interestedPartiesTable': async (item) => [item.party, item.requirement, item.requirementsAddressedThroughISMS, item.frameworks?.map(framework => framework.standard).join(', ')],
//             'scopeTable': async (item) => [TableExporter.camelCaseToSpaces(item.scopeArea), item.description],
//             'ismsRolesTable': async (item) => [item.roleName, item.roleDescription],
//             'committeeRolesTable': async (item) => [await nameFromUID(item.userId), item.teamName, item.ismsRole, item.ismsCommittee]
//         };

//         const formatter = formatters[componentName];
//         if (!formatter) {
//             throw new Error(`No formatter found for component: ${componentName}`);
//         }

//         return Promise.all(data.map(formatter));
//     }

//     private tableToSheet(componentName: string, data: { headers: string[], rows: any[][] }): XLSX.WorkSheet {
//         const sheetData = [data.headers, ...data.rows];
//         const ws = XLSX.utils.aoa_to_sheet(sheetData);

//         // Auto-size columns
//         const colWidths = sheetData[0].map((_, i) =>
//             Math.max(...sheetData.map(row =>
//                 row[i] ? String(row[i]).length : 0
//             ))
//         );

//         ws['!cols'] = colWidths.map(w => ({ wch: w + 2 }));
//         return ws;
//     }

//     /**
//      * Export all added tables to a single XLSX file
//      * @param filename The name for the exported file
//      */
//     public exportToXLSX(filename: string = 'MSG_Tables.xlsx'): void {
//         const workbook = XLSX.utils.book_new();

//         this.tables.forEach((table, sheetName) => {
//             const worksheet = this.tableToSheet(table);
//             XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
//         });

//         XLSX.writeFile(workbook, filename);
//     }

//     /**
//      * Clear all tables from the exporter
//      */
//     public clear(): void {
//         this.tables.clear();
//     }

//     /**
//      * Export all tables from component data
//      */
//     public static async exportAllTables(): Promise<{ success: boolean, errors: string[] }> {
//         const exporter = new TableExporter();
//         const workbook = XLSX.utils.book_new();
//         const errors: string[] = [];

//         const components = [
//             'objectivesTable',
//             'issueRegisterTable',
//             // 'communicationTable',
//             'legalObligationsTable',
//             'interestedPartiesTable',
//             'scopeTable',
//             'ismsRolesTable',
//             'committeeRolesTable'
//         ];

//         let hasValidData = false;

//         for (const component of components) {
//             const data = await exporter.getTableData(component);

//             if (data.error) {
//                 errors.push(`${component}: ${data.error}`);
//                 continue;
//             }
//             if (Array.isArray(data.rows) && data.rows.length > 0) {
//                 try {
//                     const sheetName = this.camelCaseToSpaces(component.replace('Table', '').substring(0, 31));
//                     const worksheet = exporter.tableToSheet(component, data);
//                     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
//                     hasValidData = true;
//                 } catch (error) {
//                     errors.push(`Error creating worksheet for ${component}: ${error.message || 'Unknown error'}`);
//                 }   
//             }
//         }

//         if (hasValidData) {
//             try {
//                 XLSX.writeFile(workbook, 'MSG_Export.xlsx');
//                 return {
//                     success: true,
//                     errors: errors.length > 0 ? errors : []
//                 };
//             } catch (error) {
//                 errors.push(`Error writing file: ${error.message || 'Unknown error'}`);
//                 return { success: false, errors };
//             }
//         }

//         return {
//             success: false,
//             errors: errors.length > 0 ? errors : ['No valid data found to export']
//         };
//     }
// }


import * as XLSX from 'xlsx';
import { fetchObjectives } from './objectivesManager.util';
import { fetchIssueRegister } from './fetchIssueRegister.util';
import { fetchLegalObligations } from './legalObligationsManager.util';
import { getInterestedParties } from './getInterestedParties.util';
import { fetchScopeData } from './scopeManager.util';
import { fetchRoles } from './rolesManager.util';
import { fetchISMSRoles } from './ismsRolesManager.util';
import { nameFromUID } from './nameFromUID.util';

export class TableExporter {
    private tables: Map<string, HTMLTableElement>;

    constructor() {
        this.tables = new Map();
    }

    /**
     * Add a table to be exported
     * @param sheetName The name for this table's sheet
     * @param table The HTML table element
     */
    public addTable(sheetName: string, table: HTMLTableElement): void {
        this.tables.set(sheetName, table);
    }

    /**
     * Convert HTML table to worksheet data
     */
    private async getTableData(componentName: string): Promise<{ headers: string[], rows: Promise<unknown[][]>, error?: string }> {
        try {
            const dataFetchers: { [key: string]: () => Promise<unknown[]> } = {
                'objectivesTable': async () => await fetchObjectives(),
                'issueRegisterTable': async () => await fetchIssueRegister(window.companyID),
                'legalObligationsTable': async () => await fetchLegalObligations(),
                'interestedPartiesTable': async () => {
                    const result = await getInterestedParties(window.companyID, { useSnapshot: false });
                    if (typeof result === 'function') {
                        return []; // Return empty array if we got an unsubscribe function
                    }
                    return Object.values(result || {}); // Convert object to array
                },
                'scopeTable': async () => await fetchScopeData(),
                'ismsRolesTable': async () => await fetchISMSRoles(),
                'committeeRolesTable': async () => await fetchRoles(),
            };

            const headerMappings: { [key: string]: string[] } = {
                'objectivesTable': ['ID', 'Objective', 'Target Date'],
                'issueRegisterTable': ['Type', 'Name', 'Description'],
                'legalObligationsTable': ['Requirement', 'Owner', 'Update Method'],
                'interestedPartiesTable': ['Party', 'Party Requirement', 'Outcome on Management System', 'Frameworks'],
                'scopeTable': ['Scope Area', 'Description'],
                'ismsRolesTable': ['Role Name', 'Description'],
                'committeeRolesTable': ['Name', 'Team', 'ISMS Role', 'ISMS Committee Role'],
            };

            const fetcher = dataFetchers[componentName];
            if (!fetcher) {
                return {
                    headers: [],
                    rows: Promise.resolve([]),
                    error: `No data fetcher found for component: ${componentName}`,
                };
            }

            console.log(`Fetching data for ${componentName}...`);

            const data = await fetcher();
            console.log(`Fetched data for ${componentName}...`, data);
            if (!data || !Array.isArray(data)) {
                return {
                    headers: [],
                    rows: Promise.resolve([]),
                    error: `Invalid data returned for component: ${componentName}`,
                };
            }

            const headers = headerMappings[componentName];
            if (!headers) {
                return {
                    headers: [],
                    rows: Promise.resolve([]),
                    error: `No header mapping found for component: ${componentName}`,
                };
            }

            const rows = await this.formatDataToRows(data, componentName);
            return { headers, rows: Promise.resolve(rows) };
        } catch (error) {
            console.error(`Error fetching data for ${componentName}:`, error);
            return {
                headers: [],
                rows: Promise.resolve([]),
                error: `Failed to fetch data: ${error.message || 'Unknown error'}`,
            };
        }
    }

    private static camelCaseToSpaces(str: string): string {
        let spaced = str.replace(/([a-z])([A-Z])/g, '$1 $2');
        spaced = spaced.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
        return spaced.replace(/\b\w/g, char => char.toUpperCase());
    }

    private async formatDataToRows(data: unknown[], componentName: string): Promise<unknown[][]> {
        const formatters: { [key: string]: (item: unknown) => Promise<unknown[]> } = {
            'objectivesTable': async (item: any) => [item.id, item.objectiveText, item.objectiveTargetDate],
            'issueRegisterTable': async (item: any) => [item.type, item.name, item.description],
            'legalObligationsTable': async (item: any) => [item.requirement, await nameFromUID(item.owner), item.updateMethod],
            'interestedPartiesTable': async (item: any) => [item.party, item.requirement, item.requirementsAddressedThroughISMS, item.frameworks?.map((framework: any) => framework.standard).join(', ')],
            'scopeTable': async (item: any) => [TableExporter.camelCaseToSpaces(item.scopeArea), item.description],
            'ismsRolesTable': async (item: any) => [item.roleName, item.roleDescription],
            'committeeRolesTable': async (item: any) => [await nameFromUID(item.userId), item.teamName, item.ismsRole, item.ismsCommittee],
        };

        const formatter = formatters[componentName];
        if (!formatter) {
            throw new Error(`No formatter found for component: ${componentName}`);
        }

        return Promise.all(data.map(formatter));
    }

    private tableToSheet(componentName: string, data: { headers: string[], rows: unknown[][] }): XLSX.WorkSheet {
        const sheetData = [data.headers, ...data.rows];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);

        // Auto-size columns
        const colWidths = sheetData[0].map((_, i) =>
            Math.max(...sheetData.map(row => (row[i] ? String(row[i]).length : 0)))
        );

        ws['!cols'] = colWidths.map(w => ({ wch: w + 2 }));
        return ws;
    }

    /**
     * Export all added tables to a single XLSX file
     * @param filename The name for the exported file
     */
    public exportToXLSX(filename: string = 'MSG_Tables.xlsx'): void {
        const workbook = XLSX.utils.book_new();

        this.tables.forEach((table, sheetName) => {
            const worksheet = this.tableToSheet(sheetName, { headers: [], rows: [] }); // Adjusted to provide empty rows and headers
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        });

        XLSX.writeFile(workbook, filename);
    }

    /**
     * Clear all tables from the exporter
     */
    public clear(): void {
        this.tables.clear();
    }

    /**
     * Export all tables from component data
     */
    public static async exportAllTables(): Promise<{ success: boolean, errors: string[] }> {
        const exporter = new TableExporter();
        const workbook = XLSX.utils.book_new();
        const errors: string[] = [];

        const components = [
            'objectivesTable',
            'issueRegisterTable',
            'legalObligationsTable',
            'interestedPartiesTable',
            'scopeTable',
            'ismsRolesTable',
            'committeeRolesTable'
        ];

        let hasValidData = false;

        for (const component of components) {
            const data = await exporter.getTableData(component);

            if (data.error) {
                errors.push(`${component}: ${data.error}`);
                continue;
            }
            if (Array.isArray(data.rows) && data.rows.length > 0) {
                try {
                    const sheetName = this.camelCaseToSpaces(component.replace('Table', '').substring(0, 31));
                    const rows = await data.rows; // Await the rows promise here
                    const worksheet = exporter.tableToSheet(component, { headers: data.headers, rows });
                    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    hasValidData = true;
                } catch (error) {
                    errors.push(`Error creating worksheet for ${component}: ${error.message || 'Unknown error'}`);
                }
            }
        }

        if (hasValidData) {
            try {
                XLSX.writeFile(workbook, 'MSG_Export.xlsx');
                return {
                    success: true,
                    errors: errors.length > 0 ? errors : [],
                };
            } catch (error) {
                errors.push(`Error writing file: ${error.message || 'Unknown error'}`);
                return { success: false, errors };
            }
        }

        return {
            success: false,
            errors: errors.length > 0 ? errors : ['No valid data found to export'],
        };
    }
}